import builder from '../builder';
import BuildingModern from '../../streamline-icons/bold/building-modern.svg';

export default builder('IconBuildingModernBold', BuildingModern);
